import type { TFunction } from 'i18next';
import { TooltipContentReachSectionType } from '../constants.ts';

export const getSectionTypeToNameMap = (t: TFunction) => ({
  [TooltipContentReachSectionType.SOURCE_PROVIDED_COUNT]: t('Source id provided'),
  [TooltipContentReachSectionType.SOURCE_MATCHED_COUNT]: t('Source id matched'),
  [TooltipContentReachSectionType.COOKIES]: t('Cookies'),
  [TooltipContentReachSectionType.DEVICES]: t('Mobile Devices'),
  [TooltipContentReachSectionType.CONNECTED_TV_DEVICES]: t('Connected TV Devices'),
  [TooltipContentReachSectionType.TOTAL_IDLS]: t('RampIDs'),
  [TooltipContentReachSectionType.IPS]: t('IP Addresses'),
  [TooltipContentReachSectionType.ID5]: t('ID5'),
});
